<arb-base-dialog [title]="data.title" [subtitle]="data.subtitle">
  <ng-container actions>
    <button mat-dialog-close class="close-btn" mat-flat-button>{{ data.confirmText }}</button>
  </ng-container>
</arb-base-dialog>